export default {
  getBanners: (state) => state.banners,
  getCacheMeta: (state) => state.cacheMeta
};
